'use memo';

import type { PropsWithChildren, ReactNode } from 'react';
import { cn } from '@/lib/cn';
import HStack from './HStack';
import { ScrollableRow } from './ScrollableRow';
export type ListToolbarProps = PropsWithChildren<{
  /**
   * 例外的に右固定したい要素。
   * 通常は Export / Switch も含め children（同一スクロール行）へ置く。
   */
  trailing?: ReactNode;
  /** ルート（見た目のバー）へ付与するクラス */
  className?: string;
  /** スクロール行コンテンツへ付与するクラス */
  contentClassName?: string;
  /**
   * ScrollButton 背景。一覧バーは通常 fill。
   * @default 'fill'
   */
  scrollButtonVariant?: 'fill' | 'bottomFill';
}>;

/**
 * 一覧・テーブル上部の Search + Filter 行用レイアウト。
 *
 * - **基本**: Search / Chip / Toggle / Export / ページ級 Switch をすべて children（同一スクロール行）へ
 * - 右端寄せ（Export 等）: children 末尾に `ml-auto shrink-0`（`trailing` は使わない）
 * - **例外**: どうしても常時可視にしたい要素のみ `trailing`
 */
export function ListToolbar({
  children,
  trailing,
  className,
  contentClassName,
  scrollButtonVariant = 'fill'
}: ListToolbarProps) {
  return <HStack className={cn('w-full min-w-0 items-center', className)}>
      <ScrollableRow rootClassName="min-w-0 flex-1" contentClassName={cn('min-h-9 min-w-full items-center gap-2', contentClassName)} scrollButtonVariant={scrollButtonVariant}>
        {children}
      </ScrollableRow>
      {trailing ? <div className="ml-2 flex shrink-0 items-center gap-2">{trailing}</div> : null}
    </HStack>;
}